export const EnterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1C2.79086 1 1 2.79086 1 5V11C1 13.2091 2.79086 15 5 15H11C13.2091 15 15 13.2091 15 11V5C15 2.79086 13.2091 1 11 1H5ZM10.76 4C10.76 3.58579 10.4242 3.25 10.01 3.25C9.5958 3.25 9.26001 3.58579 9.26001 4V8.25H5.78521L6.4922 7.52281C6.78094 7.22582 6.77425 6.75099 6.47726 6.46225C6.18027 6.17351 5.70545 6.1802 5.41671 6.47719L3.47226 8.47719C3.18926 8.76828 3.18926 9.23172 3.47226 9.52281L5.41671 11.5228C5.70545 11.8198 6.18027 11.8265 6.47726 11.5377C6.77425 11.249 6.78094 10.7742 6.4922 10.4772L5.78521 9.75H10.01C10.4242 9.75 10.76 9.41421 10.76 9V4Z"
      fill="#9CA3AF"
    />
  </svg>
);
